// src/components/ProgramCard.jsx
import React, { useEffect, useState } from 'react';

const FALLBACK_IMG = '/images/program-fallback.jpg';

/**
 * ProgramCard
 * Displays a program card with image, title, description, and CTA
 * Uses mwc-cards.css for styling
 */
export default function ProgramCard({ program = {} }) {
  const { _id, title, permalink, description } = program;
  const initialSrc = program?.image || FALLBACK_IMG;
  const [imgSrc, setImgSrc] = useState(initialSrc);
  const [hadError, setHadError] = useState(false);

  useEffect(() => {
    setImgSrc(program?.image || FALLBACK_IMG);
    setHadError(false);
  }, [program?.image]);

  const handleImageError = () => {
    if (imgSrc !== FALLBACK_IMG) {
      console.warn('[ProgramCard] Image failed, using fallback:', imgSrc);
      setImgSrc(FALLBACK_IMG);
    } else {
      setHadError(true);
    }
  };

  return (
    <article 
      className="mwc-card mwc-program-card" 
      aria-labelledby={_id ? `program-title-${_id}` : undefined}
    >
      <div className="mwc-program-card__media">
        <div className="mwc-program-card__aspect">
          <img 
            src={imgSrc} 
            alt={title ? `${title} image` : 'Program image'} 
            className="mwc-program-card__image" 
            loading="lazy" 
            decoding="async" 
            referrerPolicy="no-referrer" 
            onError={handleImageError}
          />
        </div>
      </div>
      
      <div className="mwc-program-card__body">
        <h3 
          id={_id ? `program-title-${_id}` : undefined} 
          className="mwc-program-card__title"
        >
          {title || 'Program'}
        </h3>
        
        {description && (
          <p className="mwc-program-card__desc">
            {description}
          </p>
        )}
        
        {permalink ? (
          <a 
            className="mwc-btn mwc-btn--primary mwc-program-card__cta" 
            href={permalink} 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label={`View program: ${title || 'this program'}`}
          >
            View Program →
          </a>
        ) : (
          <button 
            className="mwc-btn mwc-btn--primary mwc-program-card__cta" 
            type="button" 
            disabled 
            style={{ opacity: 0.5, cursor: 'not-allowed' }}
          >
            View Program
          </button>
        )}
        
        {hadError && (
          <div style={{ 
            fontSize: '0.75rem', 
            color: 'var(--mwc-text-light)', 
            marginTop: 8, 
            fontStyle: 'italic' 
          }}>
            (Image unavailable)
          </div>
        )}
      </div>
    </article>
  );
}